export const ROUTE_PATHS = {
  HOME: '/',
  MATO: '/mato-city-gov',
  SECRET: '/secret-door',
  BBS: '/mato-bbs',
  ADMIN: '/admin',
  KUZUNEKO_ROOM: '/kuzuneko-room',
} as const;

export const SOCIAL_LINKS = [
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/pictwork_studio',
    icon: 'instagram',
    followers: '2.3K'
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/tachiki-keinosuke-59080a309/',
    icon: 'linkedin'
  },
  {
    name: 'X',
    url: 'https://x.com/PictWorkStudio',
    icon: 'x'
  }
] as const;

export const CREATIVE_PARTNERS = [
  { name: 'Kling', role: 'AI Video Generation' },
  { name: 'Vidu', role: 'AI Cinematic Tools' },
  { name: 'SKYWORK', role: 'Creative AI Platform' }
] as const;

export interface LinkItem {
  title: string;
  description: string;
  href: string;
  icon?: React.ReactNode;
  external?: boolean;
}

export interface Character {
  name: string;
  description: string;
  species: string;
}